// eslint-disable import/no-cycle
import request from '@/utils/request'

/**
 * @apiName 获取应收管理列表
 * @apiUrl
 */
export function getReceivableList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取应收管理列表 - (包含table头部信息)
 * @apiUrl
 */
export function getReceivableListWithHeaderInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receivableList',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取账户类型
 * @apiUrl
 */
export function getAccountType(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/summary',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取账户列表
 * @apiUrl
 */
export function getAccountList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/list',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 更新用户账户状态
 * @apiUrl
 */
export function updateState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/updateState',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新增用户接口（付款账号、收款账号）
 * @apiUrl
 */
export function addAccount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/add',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 编辑用户接口
 * @apiUrl
 */
export function updateAccount(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/update',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 收款方查询接口（服务商列表查询接口，1维修厂）
 * @apiUrl
 */
export function getCollectCustomerList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/company/provider/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 应付列表查询
 * @apiUrl
 */
export function getPaymentList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 应付列表查询 - (包含table头部信息)
 * @apiUrl
 */
export function getPaymentListWithHeaderInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/paymentList',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取应收详情
 * @apiUrl
 */
export function getReceivableDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新增应收
 * @apiUrl
 */
export function addReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/signCheck/add',
    method: 'POST',
    data,
    signParams: ['sourceOrderId', 'sourceOrderType', 'receivableAmount', 'receivedAmount'],
  })
}

/**
 * @apiName 新增应付
 * @apiUrl
 */
export function addPayment(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/signCheck/add',
    method: 'POST',
    data,
    signParams: ['sourceOrderId', 'sourceOrderType', 'payAmount', 'paidAmount'],
  })
}


/**
 * @apiName 新增收款单
 * @apiUrl
 */
export function addReceipt(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/add',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 收款单列表查询
 * @apiUrl
 */
export function getReceiptList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 收款单收款方式
 * @apiUrl
 */
export function getCollectionPayMethod(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/account/type',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取收款单详情
 * @apiUrl
 */
export function getReceiptDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 编辑收款单
 * @apiUrl
 */
export function editReceipt(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/update',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取付款单列表
 * @apiUrl
 */
export function getPaymentOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/list',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取付款单详情
 * @apiUrl
 */
export function getPaymentOrderDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/detail',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 新增付款单
 * @apiUrl
 */
export function addPaymentOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/add',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 编辑付款单
 * @apiUrl
 */
export function editPaymentOrder(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/update',
    method: 'POST',
    data,
  })
}


/**
 * @apiName 修改应收单号状态
 * @apiUrl
 */
export function updateCollectionState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/state',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 修改应付单号状态
 * @apiUrl
 */
export function updatePayState(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/state',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 查看应付单详情
 * @apiUrl
 */
export function getPaymentDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/detail',
    method: 'POST',
    data,
  })
}

// 批量收款记录撤回
export function batchRecordRetract(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/revoke',
    // url: '/admin/v1/vehicle/finance/batch/receivable/record/retract',
    method: 'POST',
    data,
  })
}

export function getReceivableStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/statistic',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 批量付款列表
 * @apiUrl
 */
export function getbatchPaymentRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/list',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 批量收款添加
 * @apiUrl
 */
export function getbatchCollectionRecordAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/add',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 批量收款详情
 * @apiUrl
 */
export function getbatchCollectionRecordDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/detail',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 批量付款详情
 * @apiUrl
 */
export function getbatchPaymentRecordDetails(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/detail',
    method: 'POST',
    data,
  })
}

// 应收变更
export function receivableChangeReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeReceivable',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 批量收款单列表
 * @apiUrl
 */
export function getbatchOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/order/list',
    method: 'POST',
    data,
  })
}
// 应付变更
export function paymentChangePayment(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/changePayment',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 批量付款单列表
 * @apiUrl
 */
export function getbatchPayOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/order/list',
    method: 'POST',
    data,
  })
}
// 收款单作废
export function receivableReceiptCancel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/cancel',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 类目管理
 * @apiUrl
 */
export function getCategoryManage(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/category/list',
    method: 'POST',
    data,
  })
}

// 付款单作废
export function paymentBillCancel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/cancel',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 新增类目
 * @apiUrl
 */
export function getCategoryAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/category/add',
    method: 'POST',
    data,
  })
}
// 付款单列表统计
export function paymentBillStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/bill/statistic',
    method: 'POST',
    data,
  })
}
// 财务类目编辑
export function editCategory(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/category/edit',
    method: 'POST',
    data,
  })
}

// 收款单列表统计
export function receivableReceiptStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/statistic',
    method: 'POST',
    data,
  })
}

// 退款单金额统计
export function receivableRefundStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/refund/receipt/statistic',
    method: 'POST',
    data,
  })
}


// 批量收款单列表查询
export function getBatchReceivableOrderList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/order/list',
    method: 'POST',
    data,
  })
}

// 批量付款记录作废
export function batchPaymentRecordDiscard(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/record/discard',
    method: 'POST',
    data,
  })
}

// 批量收款记录作废
export function batchReceivableRecordDiscard(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/record/discard',
    method: 'POST',
    data,
  })
}

// 应付列表统计
export function getPaymentStatistic(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/payment/statistic',
    method: 'POST',
    data,
  })
}


// 出入库记录
export function stockList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/stockList',
    method: 'POST',
    data,
  })
}

// 订单关联信息
export function relationList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/contract/relation/record/relationList',
    method: 'POST',
    data,
  })
}

// 订单退车结算信息
export function vehiclesettlement(data = {}) {
  return request({
    url: '/admin/v1/vehicle/order/returnCar/settlementInfo',
    method: 'POST',
    data,
  })
}

// 批量调整应收
export function setBatchReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeReceivable/import',
    method: 'POST',
    data,
  })
}

// 查询导入的数据
export function getBatchReceivableList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeReceivable/getImportList',
    method: 'POST',
    data,
  })
}

// 线上批量收款新增
export function batchReceivableOnlineCreate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/online/create',
    method: 'POST',
    data,
  })
}

// 确认调整
export function changeReceivableConfirm(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeReceivable/confirm',
    method: 'POST',
    data,
  })
}

// 线上批量收款详情
export function getBatchReceivableOnlineDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/online/detail',
    method: 'POST',
    data,
  })
}

// 获取支付宝支付配置
export function getAlipayConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/config/alipay/get',
    method: 'POST',
    data,
  })
}

// 上传支付宝定时支付配置
export function postAlipayConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/config/alipay/update',
    method: 'POST',
    data,
  })
}

// 创建支付宝支付收款单
export function addAlipayReceipt(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/receipt/alipay/add',
    method: 'POST',
    data,
  })
}

// 创建退款单
export function addRefund(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/refund/receipt/add',
    method: 'POST',
    data,
  })
}

// 获取退款单列表
export function getRefundList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/refund/receipt/list',
    method: 'POST',
    data,
  })
}


// 网约钱包支付配置获取
export function getWalletWithholdConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/config/walletWithhold/get',
    method: 'POST',
    data,
  })
}
// 网约钱包支付配置修改
export function updateWalletWithholdConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/config/walletWithhold/update',
    method: 'POST',
    data,
  })
}
// 获取扣款计划列表
export function getAccruedPlanList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPlan/list',
    method: 'POST',
    data,
  })
}
// 终止扣款计划
export function abortAccruedPlan(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPlan/abort',
    method: 'POST',
    data,
  })
}

// 获取应收款项列表
export function getCollectionRecordList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/batchSelect',
    method: 'POST',
    data,
  })
}

// 应收预览接口
export function receivableAccruedPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPreview/receivable',
    method: 'POST',
    data,
  })
}
// 删除单个应计id
export function removeAccruedPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPreview/remove',
    method: 'POST',
    data,
  })
}

// 撤回审批
export function withdrawApproval(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/revoke',
    // url: '/admin/v1/vehicle/finance/batch/receivable/record/retract',
    method: 'POST',
    data,
  })
}

// 生成扣款计划
export function addAccruedPlan(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/accruedPlan/add',
    method: 'POST',
    data,
  })
}

// 确认变更减免金额
export function addReceivableConfirm(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeRelieve',
    method: 'POST',
    data,
  })
}

// 批量减免金额
export function receivableChangeRelieveImport(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeRelieve/import',
    method: 'POST',
    data,
  })
}

// 查看导入列表
export function receivableChangeRelieveGetImportList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeRelieve/getImportList',
    method: 'POST',
    data,
  })
}

// 批量减免导入提交
export function receivableConfirm(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/changeRelieve/confirm',
    method: 'POST',
    data,
  })
}

// 审批通过或是驳回 - 合并代码后先注释，若有问题再打开
// export function approvalOperation (data = {}) {
//   return request({
//     url: '/admin/v1/vehicle/approvalTask/submit',
//     method: 'POST',
//     data
//   })
// }

// 发起结算：确认新增
export function accidentSettlementAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/routines/accident/settlement/add',
    method: 'POST',
    data,
  })
}

// 部分圈选添加至预览
export function batchReceivablePartPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/part/previewAdd',
    method: 'POST',
    data,
  })
}

// 新增全部数据至预览
export function batchReceivableAllPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/all/previewAdd',
    method: 'POST',
    data,
  })
}

// 预览接口
export function batchReceivablePreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/preview',
    method: 'POST',
    data,
  })
}

// 移除单个未完成的应收
export function batchReceivableRemove(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/batchReceivable/remove',
    method: 'POST',
    data,
  })
}

// 款项分摊
export function batchReceivableSplitFee(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/splitFee',
    method: 'POST',
    data,
  })
}

// 一键设置未完成收款类目
export function setReceivableCategory(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/category/update',
    method: 'POST',
    data,
  })
}

// 本次收款金额更改
export function batchReceivableSetFieldValue(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/receivable/setFieldValue',
    method: 'POST',
    data,
  })
}
// 校验应收记录批量调整有无审核中的数据
export function receivableFilterReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/receivable/filterReceivable',
    method: 'POST',
    data,
  })
}
// 批量付款-添加相关未完成应付-新增全部数据至预览
export function paymentAllPreviewAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/all/previewAdd',
    method: 'POST',
    data,
  })
}

// 批量付款-添加相关未完成应付-确认新增（选中部分接口）
export function paymentPartPreviewAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/part/previewAdd',
    method: 'POST',
    data,
  })
}
// 批量付款-选中的相关未完成应付数据
export function paymentPreview(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/preview',
    method: 'POST',
    data,
  })
}

// 批量付款-更新已添加应付表格中某一条的【本次收款金额】
export function paymentSetFieldValue(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/batch/payment/setFieldValue',
    method: 'POST',
    data,
  })
}

// 基于车辆ID和来源单类型获取来源单ID集合
export function getSourceOrderId(data = {}) {
  return request({
    url: '/admin/v1/vehicle/common/getSourceOrderId',
    method: 'POST',
    data,
  })
}

/* 财务看板 start */
// 应收金额模块
export function getFinanceReceivable(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/board/receivable',
    method: 'POST',
    data,
  })
}

// 收款金额图表模块
export function getFinanceReceivableChart(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/board/receivable/chart',
    method: 'POST',
    data,
  })
}

// 应付金额模块
export function getFinancePayment(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/board/payment',
    method: 'POST',
    data,
  })
}

// 付款金额图表模块
export function getFinancePaymentChart(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/board/payment/chart',
    method: 'POST',
    data,
  })
}

// 欠款模块
export function getFinanceDebt(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/board/debt',
    method: 'POST',
    data,
  })
}

// 欠款金额图表模块
export function getFinanceDebtChart(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/board/debt/chart',
    method: 'POST',
    data,
  })
}

// 车辆成本和营销成本模块
export function getFinanceCost(data = {}) {
  return request({
    url: '/admin/v1/vehicle/finance/board/cost',
    method: 'POST',
    data,
  })
}
/* 财务看板 end */


// 子监管户列表获取-根据接收方、转出方
export function getSuperviseAccountList(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/subAccount/byType/list',
    method: 'POST',
    data,
  })
}

// 分账规则创建修改
export function saveDivideRule(data = {}) {
  return request({
    url: '/admin/v1/divide/rule/save',
    method: 'POST',
    data,
  })
}

// 分账规则列表查询
export function getDivideRuleList(data = {}) {
  return request({
    url: '/admin/v1/divide/rule/list',
    method: 'POST',
    data,
  })
}

// 分账规则状态修改
export function modifyDivideRuleState(data = {}) {
  return request({
    url: '/admin/v1/divide/rule/modifyState',
    method: 'POST',
    data,
  })
}

// 手动分账(转账)
export function applyDivide(data = {}) {
  return request({
    url: '/admin/v1/clearing/divide/apply',
    method: 'POST',
    data,
  })
}


// 子监管户保存
export function saveSubAccount(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/subAccount/save',
    method: 'POST',
    data,
  })
}

// 子监管户开户
export function submitSubAccount(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/subAccount/submit',
    method: 'POST',
    data,
  })
}

// 子监管户状态修改
export function modifySubAccountState(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/subAccount/modifyState',
    method: 'POST',
    data,
  })
}

// 子监管账户列表查询
export function getSubAccountList(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/subAccount/list',
    method: 'POST',
    data,
  })
}
// 更新监管账户
export function updatePayAccount(data = {}) {
  return request({
    url: '/admin/v1/maintenance/itemRentPlanLink/updatePayAccount',
    method: 'POST',
    data,
  })
}


// 子监管户明细查询
export function getSubAccountDetail(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/subAccount/detail',
    method: 'POST',
    data,
  })
}

// 子监管户余额查询
export function querySubAccountBalance(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/subAccount/balance/query',
    method: 'POST',
    data,
  })
}

// 子监管户余额提现
export function withdrawSubAccountBalance(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/subAccount/balance/withdraw',
    method: 'POST',
    data,
  })
}

// 对账单查询
export function queryReconciliationList(data = {}) {
  return request({
    url: '/admin/v1/reconciliation/list/query',
    method: 'POST',
    data,
  })
}

// 账单类型列表
export function queryTransactionList(data = {}) {
  return request({
    url: '/admin/v1/reconciliation/type',
    method: 'POST',
    data,
  })
}

// 分账规则详情
export function getDivideRuleDetail(data = {}) {
  return request({
    url: '/admin/v1/divide/rule/detail',
    method: 'POST',
    data,
  })
}

// 获取银行渠道
export function getWithholdingBankType(data = {}) {
  return request({
    url: '/admin/v1/vehicle/withholding/bank/type',
    method: 'POST',
    data,
  })
}

// 获取支付渠道(全枚举不包含开通关系)
export function getAllWithholdBankType(data = {}) {
  return request({
    url: '/admin/v1/vehicle/withholding/bank/type/all',
    method: 'POST',
    data,
  })
}

// 获取关联网约平台-新
export function getMappingListTenant(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenant/mappingListTenant',
    method: 'POST',
    data,
  })
}

// 交易明细对账单导出
export function exportList(data = {}) {
  return request({
    url: '/admin/v1/reconciliation/list/export',
    method: 'POST',
    data,
  })
}

// 查询交易明细导出结果
export function getExportResult(data = {}) {
  return request({
    url: '/admin/v1/reconciliation/list/export/result',
    method: 'POST',
    data,
  })
}

// 交易明细导出文件下载
export function downloadExportFile(data = {}) {
  return request({
    url: '/admin/v1/reconciliation/list/download',
    responseType: 'blob',
    method: 'POST',
    isExport: true,
    data,
  })
}

// 获取收款账户类型
export function getPayeeAccountType(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/getPayeeAccountType',
    method: 'POST',
    data,
  })
}

// 代扣设置-代扣收款户查看列表
export function subAccountList(data = {}) {
  return request({
    url: '/admin/v1/superviseAccount/company/subAccount/list',
    method: 'POST',
    data,
  })
}

// 支付配置-支付宝支付
export function getAlipayWithholdList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/alipay/withhold/list',
    method: 'POST',
    data,
  })
}

// 支付配置-签署支付宝支付信息展示
export function getPersonWithholdConfirmSignInfo(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/rent/order/getPersonWithholdConfirmSignInfo',
    method: 'POST',
    data,
  })
}

// 支付配置-申请开通支付宝支付
export function openAlipayWithhold(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/alipay/withhold/open',
    method: 'POST',
    data,
  })
}

// 支付配置-签约二维码展示
export function getAlipayWithholdSignQrCode(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/alipay/withhold/sign/qrcode',
    method: 'POST',
    data,
  })
}

// 支付配置-催签
export function urgeAlipayWithholdSign(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/contract2/urgeSign',
    method: 'POST',
    data,
  })
}

// 解约记录列表查询
export function getBreakOffWithholdList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/list/breakOff',
    method: 'POST',
    data,
  })
}

// 个人代扣规则配置
export function getWithholdConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/config/query',
    method: 'POST',
    data,
  })
}

// 逾期金额计算
export function getAlipayWithholdOverdue(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/overdue',
    method: 'POST',
    data,
  })
}

// 实际到账金额计算
export function actualAlipayWithholdAmount(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/alipay/withhold/actualAmount',
    method: 'POST',
    data,
  })
}

// 发起个人代扣
export function startAlipayWithhold(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/alipay/withhold/execute',
    method: 'POST',
    data,
  })
}

// 解约消息通知
export function notifyAlipayWithholdBreakOff(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/alipay/breakOff/notify',
    method: 'POST',
    data,
  })
}

//
export function verifyStartAlipayWithhold(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/alipay/withhold/start',
    method: 'POST',
    data,
  })
}

export function checkAlipayWithholdAccountStatus(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/checkAccountStatus',
    method: 'POST',
    data,
  })
}


export function alipaySignDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/signDetail',
    method: 'POST',
    data,
  })
}

export function alipayGetPersonWithholdConfirmSignInfo(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/getPersonWithholdConfirmSignInfo',
    method: 'POST',
    data,
  })
}
// 支付宝支付合同催签接口
export function alipaywithholdurgeSign(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/urgeSign',
    method: 'POST',
    data,
  })
}
// 支付宝支付合同撤回接口
export function alipayWithholdCancel(data = {}) {
  return request({
    url: '/admin/v1/vehicle/alipay/withhold/cancel',
    method: 'POST',
    data,
  })
}

// 代扣收账户-绑卡
export function bindWangshangWithholdAccount(data) {
  return request({
    url: '/admin/v1/vehicle/withholding/bankCard/bind',
    method: 'POST',
    data,
  })
}

// 一键换车校验接口
export function checkBeforeChangeCar(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/rent/order/checkBeforeChangeCar',
    method: 'POST',
    data,
  })
}

// 退车解约校验接口
export function checkBeforeReturnCar(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/checkBeforeReturnCar',
    method: 'POST',
    data,
  })
}

// 发起一键换车
export function requestChangeCar(data) {
  return request({
    url: '/admin/v1/vehicle/rent/order/changeCar',
    method: 'POST',
    data,
  })
}

// 换车验车(第二步)
export function updateCheckAndChangeCar(data) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/changeCar/update',
    method: 'POST',
    data,
  })
}

// 获取一键换车第二步数据
export function getChangeCarData(data) {
  return request({
    url: '/admin/v1/vehicle/car/stockLog/changeCar/get',
    method: 'POST',
    data,
  })
}

// 授权列表
export function getSpAuthList(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/list',
    method: 'POST',
    data,
  })
}

// 解除授权
export function cancelSpAuth(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/breakOff',
    method: 'POST',
    data,
  })
}

// 授权日志
export function getSpAuthLog(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/log/list',
    method: 'POST',
    data,
  })
}

// 授权详情
export function getSpAuthDetail(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/detail',
    method: 'POST',
    data,
  })
}

// 主体详情
export function getAuthAppleEntityDetail(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/merchant/authApplyEntityDetail',
    method: 'POST',
    data,
  })
}

// 提交授权申请
export function submitSpAuth(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/apply',
    method: 'POST',
    data,
  })
}

// 复用已有授权
export function useExistSpAuth(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/useExist',
    method: 'POST',
    data,
  })
}

// 重新生成授权码
export function regenerateSpAuthCode(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/newAuthCode',
    method: 'POST',
    data,
  })
}

// 确认授权
export function confirmSpAuth(data) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/spAuth/confirm',
    method: 'POST',
    data,
  })
}
